import { render, staticRenderFns } from "./embed-component.vue?vue&type=template&id=1119b580&scoped=true&"
import script from "./embed-component.vue?vue&type=script&lang=ts&"
export * from "./embed-component.vue?vue&type=script&lang=ts&"
import style0 from "./embed-component.vue?vue&type=style&index=0&id=1119b580&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1119b580",
  null
  
)

export default component.exports